import React, { FC } from 'react';

import { MeasureUnit } from '@domains/product';

import { CurrencyPresenter } from '@components/common/CurrencyPresenter/CurrencyPresenter';

type ProductPricePerUnitProps = {
    measureUnit: MeasureUnit;
    digit?: number;
    className?: string;
};
export const ProductPricePerUnit: FC<ProductPricePerUnitProps> = (props) => {
    const { measureUnit, digit = 0, className } = props;

    return (
        <div className={className}>
            Цена <CurrencyPresenter amount={measureUnit.price_in_kopecks.new} digits={digit} />{' '}
            за&nbsp;1&nbsp;
            {measureUnit.type.name}
        </div>
    );
};
